var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"image-section",class:[
    _vm.loading && 'image-section--loading',
    _vm.isMobile ? 'image-section--mobile' : 'image-section--desktop',
  ]},[_c('div',{staticClass:"featured-image-container"},[_c('client-only',[(_vm.loading)?[_c('div',{staticClass:"hg-skeleton image-skeleton"})]:(_vm.imagesDisplay.length > 0)?[_c('HgDealImageGallery',{attrs:{"images":_vm.imagesDisplay,"height":_vm.isMobile ? 320 : 520},on:{"onHandleScroll":_vm.handleGalleryScroll}})]:_vm._e()],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }